module.exports = {"211223100":"西丰镇","211223101":"平岗镇","211223102":"郜家店镇","211223103":"凉泉镇","211223104":"振兴镇","211223105":"安民镇","211223106":"天德镇","211223107":"房木镇","211223108":"柏榆镇","211223109":"陶然镇","211223110":"钓鱼镇","211223111":"更刻镇","211223204":"德兴满族乡","211223206":"明德满族乡","211223209":"成平满族乡","211223211":"和隆满族乡","211223212":"营厂满族乡","211223213":"金星满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211223.json
// module id = 674
// module chunks = 0